(function () {
  'use strict';

  /*
   * ============================================================
   * GM WATCHES — ANNOUNCEMENT BAR JS
   * ============================================================
   * مسؤول عن:
   * - تبديل الرسائل
   * - مدة ظهور الرسالة
   * - تشغيل / إيقاف التبديل
   * - دعم Shopify Theme Editor
   * - منع تكرار الـ timers
   * ============================================================
   */

  var GMAnnouncementBar = window.GMAnnouncementBar || {};

  window.GMAnnouncementBar = GMAnnouncementBar;


  /*
   * ------------------------------------------------------------
   * INIT SECTION
   * ------------------------------------------------------------
   */

  function init(section) {

    if (!section) {
      return;
    }

    /*
     * لو الـ section كان شغال قبل كده
     * نوقف النسخة القديمة أولًا
     */

    if (section.__gmAnnouncementBar) {
      section.__gmAnnouncementBar.destroy();
    }


    var messagesContainer =
      section.querySelector(
        '[data-gm-announcement-messages]'
      );


    if (!messagesContainer) {
      return;
    }


    var messages =
      Array.prototype.slice.call(
        messagesContainer.querySelectorAll(
          '[data-gm-announcement-message]'
        )
      );


    if (!messages.length) {
      return;
    }


    /*
     * ----------------------------------------------------------
     * SETTINGS
     * ----------------------------------------------------------
     */

    var autoplay =
      section.dataset.autoplay === 'true';


    var duration =
      parseInt(
        section.dataset.duration,
        10
      );


    if (
      isNaN(duration) ||
      duration < 1
    ) {
      duration = 5;
    }


    var transitionSpeed =
      parseInt(
        section.dataset.transitionSpeed,
        10
      );


    if (
      isNaN(transitionSpeed) ||
      transitionSpeed < 0
    ) {
      transitionSpeed = 500;
    }


    var transition =
      section.dataset.transition || 'fade';


    var slideDirection =
      section.dataset.slideDirection || 'rtl';


    /*
     * ----------------------------------------------------------
     * CSS VARIABLES
     * ----------------------------------------------------------
     */

    messagesContainer.style.setProperty(
      '--gm-ab-transition-speed',
      transitionSpeed + 'ms'
    );


    /*
     * ----------------------------------------------------------
     * SLIDE DIRECTION
     * ----------------------------------------------------------
     */

    if (transition === 'slide') {

      var distance =
        getComputedStyle(
          section
        ).getPropertyValue(
          '--gm-ab-slide-distance'
        );


      if (slideDirection === 'ltr') {

        messagesContainer.style.setProperty(
          '--gm-ab-slide-distance',
          '-' + distance.trim()
        );

      } else {

        messagesContainer.style.setProperty(
          '--gm-ab-slide-distance',
          distance.trim()
        );

      }

    }


    /*
     * ----------------------------------------------------------
     * STATE
     * ----------------------------------------------------------
     */

    var currentIndex = 0;

    var timer = null;

    var destroyed = false;


    /*
     * ----------------------------------------------------------
     * MAKE SURE FIRST MESSAGE IS ACTIVE
     * ----------------------------------------------------------
     */

    messages.forEach(
      function (message, index) {

        message.classList.toggle(
          'is-active',
          index === 0
        );

      }
    );


    /*
     * ----------------------------------------------------------
     * SHOW MESSAGE
     * ----------------------------------------------------------
     */

    function showMessage(index) {

      if (destroyed) {
        return;
      }


      if (
        index < 0 ||
        index >= messages.length
      ) {
        return;
      }


      if (index === currentIndex) {
        return;
      }


      messages[currentIndex].classList.remove(
        'is-active'
      );


      messages[index].classList.add(
        'is-active'
      );


      currentIndex = index;
    }


    /*
     * ----------------------------------------------------------
     * NEXT MESSAGE
     * ----------------------------------------------------------
     */

    function next() {

      var nextIndex =
        currentIndex + 1;


      if (
        nextIndex >= messages.length
      ) {
        nextIndex = 0;
      }


      showMessage(nextIndex);
    }


    /*
     * ----------------------------------------------------------
     * START
     * ----------------------------------------------------------
     */

    function start() {

      stop();

      if (destroyed || !autoplay || messages.length <= 1 || document.hidden) {
        return;
      }

      timer = window.setInterval(next, duration * 1000);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });


    /*
     * ----------------------------------------------------------
     * STOP
     * ----------------------------------------------------------
     */

    function stop() {

      if (timer !== null) {

        window.clearInterval(timer);

        timer = null;
      }
    }


    /*
     * ----------------------------------------------------------
     * DESTROY
     * ----------------------------------------------------------
     */

    function destroy() {

      destroyed = true;

      stop();

      messages.forEach(
        function (message) {

          message.classList.remove(
            'is-active'
          );

        }
      );
    }


    /*
     * ----------------------------------------------------------
     * CONTROLLER
     * ----------------------------------------------------------
     */

    section.__gmAnnouncementBar = {

      start: start,

      stop: stop,

      next: next,

      destroy: destroy

    };


    /*
     * ----------------------------------------------------------
     * START
     * ----------------------------------------------------------
     */

    start();
  }


  /*
   * ============================================================
   * INIT ALL
   * ============================================================
   */

  function initAll() {

    var sections =
      document.querySelectorAll(
        '.gm-announcement-bar'
      );


    Array.prototype.forEach.call(
      sections,
      function (section) {

        init(section);

      }
    );
  }


  /*
   * ============================================================
   * DOM READY
   * ============================================================
   */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }


  /*
   * ============================================================
   * SHOPIFY THEME EDITOR
   * ============================================================
   */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      if (
        !event.detail ||
        !event.detail.sectionId
      ) {
        return;
      }


      var section =
        document.getElementById(
          'GMAnnouncementBar-' +
          event.detail.sectionId
        );


      if (section) {

        init(section);

      }

    }
  );


  /*
   * ------------------------------------------------------------
   * SECTION UNLOAD
   * ------------------------------------------------------------
   */

  document.addEventListener(
    'shopify:section:unload',
    function (event) {

      if (
        !event.detail ||
        !event.detail.sectionId
      ) {
        return;
      }


      var section =
        document.getElementById(
          'GMAnnouncementBar-' +
          event.detail.sectionId
        );


      if (
        section &&
        section.__gmAnnouncementBar
      ) {

        section
          .__gmAnnouncementBar
          .destroy();

      }

    }
  );


  /*
   * ------------------------------------------------------------
   * SECTION REORDER
   * ------------------------------------------------------------
   */

  document.addEventListener(
    'shopify:section:reorder',
    function () {

      initAll();

    }
  );


  /*
   * ------------------------------------------------------------
   * GLOBAL API
   * ------------------------------------------------------------
   */

  GMAnnouncementBar.init =
    init;

  GMAnnouncementBar.initAll =
    initAll;

})();